import ProductAddToBag from '@moncler/components/product/ProductActionAddToBag';
import Button from '@ui/button/Button';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import { getSizeVariations } from '@utils/product';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductImage from './ProductImage';
const ProductPushRefillModal = (props) => {
    var _a;
    const { t } = useTranslation();
    let sizeVariations = getSizeVariations(props.product);
    return (React.createElement(ModalDialog, { hideHeader: true, noPadding: true, closeInvertedSm: true, isOpen: props.isOpen, onRequestClose: props.onRequestClose, contentLabel: props.title },
        React.createElement("div", { className: "product-refill" },
            React.createElement("div", { className: "product-refill__main" },
                React.createElement(ProductImage, { img: (_a = props.product) === null || _a === void 0 ? void 0 : _a.imgs, type: "F" })),
            React.createElement("div", { className: "product-refill__detail" },
                React.createElement("div", null,
                    React.createElement("h2", { className: "dialog__title" }, props.title),
                    React.createElement("h3", { className: "dialog__white-title" }, props.product.productName),
                    React.createElement("h3", null, props.product.productName),
                    React.createElement("p", null, props.product.longDescription || props.product.shortDescription)),
                React.createElement("div", { className: "mt-24" },
                    React.createElement(ProductAddToBag, { product: props.product, size: sizeVariations[0], callback: props.onRequestClose, updateErrorMessage: props.updateErrorMessage, pushAnalytics: () => {
                            analytics.perfumeWantRefill('add to bag');
                            analytics.addToCartRefill(props.product);
                        } }),
                    React.createElement(Button, { type: "button", cls: ['button--secondary'], onClick: () => {
                            analytics.perfumeWantRefill('no thanks');
                            props.onRequestClose();
                        } }, t('button.norefill')))))));
};
export default ProductPushRefillModal;
